// extracted by mini-css-extract-plugin
module.exports = {"cardLoader":"Skeleton_cardLoader__PggBr","skeletonWrapper":"Skeleton_skeletonWrapper__pEUX9"};